import { createAction, createApiActions } from '@ws/shared/utils';

import { IAuthStatusAction, USER_SET_AUTH_STATUS, USER_GET_INFO, USER_LOGOUT } from './user.types';

export const getUserInfo = createApiActions(USER_GET_INFO);
export const logoutUser = createApiActions(USER_LOGOUT);

export const setUserAuthStatus = createAction<IAuthStatusAction>(USER_SET_AUTH_STATUS);
